import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { checkMenus, checkTokenAuth } from 'shared/lib/authUtils';

const NonTokenRoute = () => {
  const isAuthenticated = checkTokenAuth();
  const isAuthorized = isAuthenticated;
  const dataMenu = checkMenus();

  const [firstMenu, setFirstMenu] = useState('/login');

  useEffect(() => {
    const calculatedMenu = isAuthorized
      ? dataMenu?.[0]?.sub_menus
        ? dataMenu?.[0]?.sub_menus?.[0]?.frontend_endpoint
        : dataMenu?.[0]?.frontend_endpoint
      : '/login';

    setFirstMenu(calculatedMenu);
  }, [isAuthorized, dataMenu]);

  return isAuthorized ? <Navigate to={firstMenu} replace /> : <Outlet />;
};

export default NonTokenRoute;
